import { Buffer } from 'buffer';
import * as base64js from 'base64-js';
import process from 'process';

(window as any).Buffer = Buffer;
(window as any).process = process;

// Intercept require before Buffer uses it
(window as any).require = (module: string) => {
    if (module === 'base64-js') return base64js;
    throw new Error(`Dynamic require not supported: ${module}`);
};
